import { useSelector } from "src/store";
import { makeStyles } from "tss-react/mui";

import { selectBatchActionIsActiveDevice, selectBatchActionIsActiveLicense } from "@devices/store";
import { Theme } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { DangerOutlinedButton } from "@shared/CustomButton";
import { MinimalTableCell, MinimalTableHeader, MinimalTableHeaderCell } from "@shared/table/MinimalTableComponents";

const useStyles = makeStyles()((theme: Theme) => ({
    tableContainer: {
        overflow: "hidden",
    },
    table: {
        tableLayout: "fixed",
    },
    tableCell: {
        borderBottom: `1px solid ${theme.palette.emteria.border.secondary}`,
    },
    removeItemIcon: {
        cursor: "pointer",
        color: theme.palette.emteria.error,
        borderRadius: 5,
        border: "1px solid " + theme.palette.emteria.error,
        fontSize: "16px",
        boxSizing: "border-box",
        padding: theme.spacing(1),
    },
}));

interface PaneTableProps {
    firstColumn: string;
    tableItems: TableRowItem[];
    handleRemoveBatchItem: (id: number) => void;
}

interface TableRowItem {
    name?: string;
    activationCode?: string;
    id: number;
}

const PaneTable = ({ firstColumn, tableItems, handleRemoveBatchItem }: PaneTableProps) => {
    const { classes } = useStyles();
    const isBatchActionLicense = useSelector(selectBatchActionIsActiveLicense);
    const isBatchActionDevice = useSelector(selectBatchActionIsActiveDevice);

    return (
        <TableContainer component={Paper} className={classes.tableContainer}>
            <Table aria-label="simple table" className={classes.table}>
                <MinimalTableHeader>
                    <TableRow>
                        <MinimalTableHeaderCell align="left">{firstColumn}</MinimalTableHeaderCell>
                        <MinimalTableHeaderCell align="right"></MinimalTableHeaderCell>
                    </TableRow>
                </MinimalTableHeader>
                <TableBody>
                    {tableItems.map(({ id, activationCode, name }) => {
                        return (
                            <TableRow key={id}>
                                <MinimalTableCell align="left" className={classes.tableCell}>
                                    <div>{isBatchActionLicense || isBatchActionDevice ? activationCode : name}</div>
                                </MinimalTableCell>
                                <MinimalTableCell align="right" className={classes.tableCell}>
                                    <DangerOutlinedButton
                                        className={classes.removeItemIcon}
                                        onClick={() => handleRemoveBatchItem(id)}
                                    >
                                        <i className="fa-solid fa-trash-alt" />
                                    </DangerOutlinedButton>
                                </MinimalTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PaneTable;
